<template>
    <el-drawer title="开闭线管理" :visible.sync="dialogVisible"  size="1000px" :modal-append-to-body="false" direction="rtl" :wrapperClosable="false"
	 class="customer-drawer-common add-edit-effect">
		<section>
			<div class="add-edit-effect__content">
				<h1>开线（上班）时间设置</h1>
				<AddEditItem v-on="$listeners" :modelData="workday" :current_row="current_row" @updateModel="updateModel" @getWorkDayList="getWorkDayList"/>
			</div>
            <div class="add-edit-effect__content">
				<h1> 闭线（节假日）时间设置</h1>
				<AddEditItem v-on="$listeners" :modelData="holiday" :current_row="current_row" @updateModel="updateModel" @getHolidayList="getHolidayList"/>
			</div>
             <div class="add-edit-effect__content">
				<h1> 特殊上班时间设置</h1>
				<AddEditItem v-on="$listeners" :modelData="exceptionday" :current_row="current_row" @updateModel="updateModel" @getHolidayList="getHolidayList"/>
			</div>
			<div class="add-edit-effect__desc">
				<span>注意</span>
				<ol>
					<li>1. 同类时间设置为 并集关系</li>
					<li>2. 不同类时间优先级为：特殊上班时间＞闭线时间＞开线时间。根据客人进线时间，系统会按优先级顺序判断进线时间属于何种时间</li>
				</ol>
			</div>
		</section>
		<div class="footer">
			<el-button @click="dialogVisible = false" size="mini">关 闭</el-button>
		</div>
	</el-drawer>
</template>
<script>
import AddEditItem from './addEditItem.vue';
 export default {
     components:{
         AddEditItem
     },
     data(){
         return {
			 current_row:'',//当前行信息
             dialogVisible:false,
             workday:{
                type:'workday',
				loading:false,
                rules: {
                    workdayWeek:{required:true,message:"必填字段",trigger:"change"},
                    time:{required:true,message:"必填字段",trigger:"change"},
                },
                tableData:[{
                    workdayWeek:"",
                    time:'',
                }],
				initForm:{
					workdayWeek:"",
					time:'',
				},
                column:[
                    {
                        label:'日期',
                        prop:'workdayWeek',
                        slotScope:true,
                        width:400
                    },{
                        label:'时间',
                        prop:'time',
                        slotScope:true,
                    },{
                        label:'操作',
                        width:150,
                        prop:'action',
                        slotScope:true,
                    }
                ]
             },
             holiday:{
                 type:'holiday',
				 loading:false,
                 rules: {
                    date:{required:true,message:"必填字段",trigger:"change"},
                    remark:{required:true,message:"必填字段",trigger:"blur"},
                    file:{required:true,message:"必填字段",trigger:"change"},
                },
                tableData:[{
                    remark:"",
                    date:'',
                    file:''
                }],
				initForm:{
					remark:"",
					date:'',
					file:''
				},
                column:[
                    {
                        label:'日期',
                        prop:'date',
                        slotScope:true,
                    },
					// {
					//   label:'备注',
					//   prop:'remark',
					//   slotScope:true,
					// },
					{
                        label:'文件',
                        prop:'file',
                        slotScope:true,
                        align:'center'
                    },{
                        label:'操作',
                        prop:'action',
                        slotScope:true,
                        width:150,
                    }
                ]
             },
             exceptionday:{
                 type:'exceptionday',
				 loading:false,
                 rules: {
                    date:{required:true,message:"必填字段",trigger:"change"},
                    remark:{required:true,message:"必填字段",trigger:"blur"},
                },
                tableData:[{
                    remark:"",
                    date:'',
                }],
				initForm:{
					remark:"",
					date:'',
				},
                column:[
                    {
                        label:'日期',
                        prop:'date',
                        slotScope:true,
                    },
					// {
					// 	label:'备注',
					// 	prop:'remark',
					// 	slotScope:true,
					// },
					{
                        label:'操作',
                        prop:'action',
                        slotScope:true,
                        width:150,
                    }
                ]
             },
			 listQuery:{
				 brand:this.$store.state.user.brandId,
				 pageNumber:1,
				 pageSize:99,
				 skillgroup:''
			 }
         } 
     },
     methods:{
         onShow(row){
             this.dialogVisible = true;
			 this.current_row = row;
			 this.listQuery.skillgroup = row.skillGroup;
			 this.getWorkDayList(row);
			 this.getHolidayList(row);
         },
		 updateModel(params){
			 this.$set(this[params.type],params.key,params.loading);
		 },
		 getWorkDayList(row){
			 if(row){
				 if(Number(row.workdayCount) == 0){
					 this.workday.tableData = [{
						time:'',
						workdayWeek:''
					 }]
					 return;
				 }
			 }
			this.$api.apiGetWorkdayListForSystem(this.listQuery).then(res => {
		 		if(res.errcode != 0) return;
				let result = [];
				res.data.map(item => {
					result.push({
						time:[item.beginTime,item.endTime],
						workdayWeek:this.formatWorkdayWeek(item.workdayWeek),
						id:item.id,
						skillgroup:item.skillgroup,
						disabled:true
					})
				})
				this.workday.tableData = result;
		 
		 	})
		 },
		 getHolidayList(row){
			 if(row){
				 if(Number(row.holidayCount) == 0 && Number(row.specialCount) == 0){
						 this.holiday.tableData = [{
							date:'',
							file:''
						 }]
						 this.exceptionday.tableData = [{
							date:''
						 }]
						 return;
				 }
			 }
		 	let params = JSON.parse(JSON.stringify(this.listQuery));
		 	this.$api.apiGetHolidayListForSystem(params).then(res => {
		 		if(res.errcode != 0) return;
				let result = [];
				let exceptiondayResult = [];
		 		res.data.map(item => {
					result.push({
						date:[item.beginTime,item.endTime],
						id:item.id,
						skillgroup:item.skillgroup,
						file:item.promptFile,
						holidayType:item.holidayType,
						disabled:true
					})
				})
				this.holiday.tableData = result.filter(el => el.holidayType == '0');
				this.exceptionday.tableData = result.filter(el => el.holidayType == '1');
		 	})
		 },
		 formatWorkdayWeek(data){
			 let lists = data ? data.split('|') : [];
			 let i = 0;
			 let result = [];
			 const apiList = ['1','2','3','4','5','6','7'];//['周日'....'周六'];
			 lists.map((item,index) => {
				 if(item == 1){
					 i++;
					result.push(['week',apiList[index]])
				 }
			 })
			 if(i == 7) return [['8']]
			 return result;
		 }
     }
 }
</script>